declare const API_CONFIG: 'dev' | 'test' | 'uat' | 'prod';

// 全局环境变量
export const GLOBAL_ENV = API_CONFIG;


// 环境枚举
export enum EnvEnum {
	DEV = 'dev',	// 开发
	TEST = 'test',	// 测试
	UAT = 'uat',	// 预发布
	PROD = 'prod',	// 生产
}


// header的高度配置
export const HEADER_H: number = 56;
// footer的高度配置<只在PC模式生效>
export const FOOTER_H: number = 244;
// ICP备案号外部跳转地址
export const ICP_RECORD_CODE_LINK = 'https://beian.miit.gov.cn';
// 川公网安全备案号外部跳转地址
export const PUBLIC_RECORD_CODE_LINK = 'https://beian.mps.gov.cn/#/query/webSearch?code=51010502015152';





